export default __webpack_public_path__ + "static/media/hrm-1.9035617d.png";